export const createMobileSlice = (set, get) => ({
  reports: [],
  setReports: value => set(() => ({ reports: value }))
});
